import React, { useEffect, useState } from "react";
import { apiPost } from "../../API/Api_Url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function SupplierNotificationModel({ isOpen, onClose, notifications, GetAllNotification }) {
    const navigate = useNavigate()
    const [IsLoading, setIsLoading] = useState(false);

    const unreadNotificationIds = notifications
        ?.filter((n) => !n.Isread)
        ?.map((n) => n._id) || [];

    const onMarkAllRead = async (notificationIds) => {

        const payload = {
            notificationIds
        };

        try {
            setIsLoading(true);
            let endpoint = 'api/material-supplier/MarkMultipleNotificationAsRead';
            const response = await apiPost(endpoint, payload);
            toast.success(response?.data?.message || response?.message || "Requirement uploaded successfully!");
            GetAllNotification()
            setIsLoading(false);
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const onMarkRead = async (notificationIds) => {

        const payload = {
            notificationIds: notificationIds
        };
        try {
            setIsLoading(true);
            let endpoint = 'api/material-supplier/MarkMultipleNotificationAsRead';
            const response = await apiPost(endpoint, payload);
            toast.success(response?.data?.message || response?.message || "Notification Read!");
            GetAllNotification()
            setIsLoading(false);
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const requirementNavigate = (notification) => {
        if (!notification?._id) return;

        onMarkRead([notification._id]);

        const typeMap = {
            MaterialRequest: {
                SelectedTab: "All Pending Material Request",
                RequirementState: "All",
            },
        };

        const targetState = typeMap[notification?.Type];

        if (targetState) {
            navigate("/profile", { state: targetState });
        } else {
            console.warn("Unknown notification type:", notification?.Type);
            navigate("/profile");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm transition-opacity duration-300">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md sm:max-w-lg p-6 animate-slideUp mx-4">
                <div className="flex justify-between items-center border-b border-gray-200 pb-4">
                    <h2 className="text-2xl font-bold text-gray-900">Notifications</h2>
                    <div className="flex items-center gap-4">
                        {unreadNotificationIds.length > 0 && (
                            <button
                                onClick={() => onMarkAllRead(unreadNotificationIds)}
                                className="text-blue-600 text-sm font-medium hover:text-blue-700 transition duration-200"
                            >
                                Mark all as read
                            </button>
                        )}
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700 transition duration-200 text-lg"
                            aria-label="Close modal"
                        >
                            ✕
                        </button>
                    </div>
                </div>

                <div className="mt-6 max-h-[400px] overflow-y-auto space-y-4 pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                    {notifications?.length > 0 ? (
                        notifications?.map((note) => (
                            <div
                                key={note._id}
                                className={`rounded-lg p-4 border border-gray-200 hover:shadow-lg transition-all duration-200 flex justify-between items-start ${note.Isread
                                    ? "bg-gray-50 border-l-4 border-gray-300"
                                    : "bg-blue-50 border-l-4 border-blue-600"
                                    }`}
                            >
                                <div onClick={() => { requirementNavigate(note) }} className="flex-1 pr-4">
                                    <p
                                        className={`text-sm leading-relaxed ${note.Isread ? "text-gray-600" : "text-gray-900 font-semibold"
                                            }`}
                                    >
                                        {note?.Text}
                                    </p>
                                    <p className="text-xs text-gray-500 mt-2">
                                        {new Date(note?.createdAt).toLocaleString("en-US", {
                                            weekday: "short",
                                            month: "short",
                                            day: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </p>
                                </div>
                                {!note.Isread && (
                                    <button
                                        onClick={() => onMarkRead([note._id])}
                                        className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-full transition duration-200 whitespace-nowrap"
                                    >
                                        Mark as read
                                    </button>
                                )}
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-500 text-center py-8">No notifications to show</p>
                    )}
                </div>

                <div className="mt-6 border-t border-gray-200 pt-4 flex justify-end">
                    <button
                        onClick={onClose}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg font-medium shadow-md transition duration-200"
                    >
                        Close
                    </button>
                </div>

                <style>
                    {`
                        @keyframes slideUp {
                            from { transform: translateY(30px); opacity: 0; }
                            to { transform: translateY(0); opacity: 1; }
                        }
                        .animate-slideUp {
                            animation: slideUp 0.4s ease-out;
                        }
                        .scrollbar-thin {
                            scrollbar-width: thin;
                        }
                        .scrollbar-thumb-gray-300::-webkit-scrollbar-thumb {
                            background-color: #d1d5db;
                            border-radius: 6px;
                        }
                        .scrollbar-track-gray-100::-webkit-scrollbar-track {
                            background-color: #f3f4f6;
                        }
                        .scrollbar-thin::-webkit-scrollbar {
                            width: 6px;
                        }
                    `}
                </style>
            </div>
        </div>
    );
}

export default SupplierNotificationModel;